import { JetView } from 'webix-jet';

/**
 * Class representing a filter view for approval quota retraction.
 * @extends JetView
 */
export default class FilterApprovalQuotaRetractionView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration

        // Left section of the form with input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker', // Datepicker input
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Id', // ID input
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label for ID input
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'UserCreate', // User creation input
                            label: "<span class='icon-mail'></span>" + _('Usuario Creó'), // Label for user creation input
                            labelPosition: 'top',
                            placeholder: _('Usuario Creó'), // Placeholder text
                        },
                        {
                            view: 'richselect',
                            name: 'Type', // Type selection input
                            label: _('Tipo de Saldo'), // Label for type selection
                            labelPosition: 'top',
                            placeholder: _('Tipo de Saldo'), // Placeholder text
                            options: [
                                { id: '0', value: _('Saldo de Recargas') }, // Option for recharge balance
                                { id: '1', value: _('Saldo de Juego') }, // Option for game balance
                            ],
                        },
                    ],
                },
            ],
        };

        // Second left section of the form with additional input fields
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'State', // State selection input
                            label: _('Estado'), // Label for state selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'), // Placeholder text
                            options: [
                                { id: '', value: _('Pendiente') }, // Option for pending state
                                { id: '0', value: _('Aprobada') }, // Option for approved state
                                { id: '1', value: _('Rechazada') }, // Option for rejected state
                            ],
                        },
                        {
                            view: 'text',
                            name: 'ValueMinimum', // Minimum value input
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'), // Label for minimum value input
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum', // Maximum value input
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'), // Label for maximum value input
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 190 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the first left section
                },
            ],
        };

        // Second upper section of the form
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 190 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Contains the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Contains the second upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('requests:filter', [filterdata]); // Triggers filter event
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            id: 'formFilter', // ID for the form
            rows: [upper_section, accordion_section, buttons], // Contains all sections
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
